import { Component, HostBinding } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolPageState } from './sol-page.state';

@Component({
  selector: 'sol-page',
  imports: [],
  templateUrl: './sol-page.component.html',
})
export class SolPageComponent extends AbstractComponent<SolPageState> {
  constructor() {
    super(SolPageState.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return 'sol-page';
  }
}
